import React, {Component} from 'react'

import ChatLogItemGeneral from '../ChatLogItemGeneral/index'
import ChatLogItemMotd from '../ChatLogItemMotd/index'
import ChatLogItemTip from '../ChatLogItemTip/index'
import ChatLogItemGift from '../ChatLogItemGift/index'
import ChatLogItemWallPost from '../ChatLogItemWallPost/index'
import ChatLogItemExclusionApplied from '../ChatLogItemExclusionApplied/index'
import ChatLogItemPersonalRoomActivated from '../ChatLogItemPersonalRoomActivated/index'
import ChatLogItemShowroomActivated from '../ChatLogItemShowroomActivated/index'
import ChatLogItemMembership from '../ChatLogItemMembership/index'
import ChatLogItemCensored from '../ChatLogItemCensored/index'

import {
    TIP_NOTIFICATION,
    GIFT_NOTIFICATION,
    WALL_POST_NOTIFICATION,
    EXCLUSION_APPLIED_NOTIFICATION,
    PERSONAL_ROOM_ACTIVATED_NOTIFICATION,
    SHOWROOM_ACTIVATED_NOTIFICATION,
    MEMBERSHIP_GIFT_NOTIFICATION,
    USER_MUTED_NOTIFICATION,
    USER_UNMUTED_NOTIFICATION
} from '../../../constants/serviceMessage';

import {MESSAGE_MOTD} from '../../../constants/roomMessages';

class ChatLogItem extends Component {
    shouldComponentUpdate(nextProps, nextState) {
        for (var i in this.props) {
            if (this.props[i] !== nextProps[i]) {
                return true;
            }
        }

        return false;
   }

    render() {
        let {type, message, currentUser, user, isMainRoom, currentRoomInfo, ...restProps} = this.props;

        if (type === MESSAGE_MOTD || message.mid === 'motd') {
            return <ChatLogItemMotd message={message}/>;
        } else if (type === GIFT_NOTIFICATION) {
            return <ChatLogItemGift message={message} currentUser={currentUser}/>
        } else if (type === WALL_POST_NOTIFICATION) {
            return <ChatLogItemWallPost message={message} currentUser={currentUser}/>
        } else if (type === EXCLUSION_APPLIED_NOTIFICATION) {
            return <ChatLogItemExclusionApplied message={message} currentRoomInfo={currentRoomInfo}/>
        } else if (isMainRoom && type === PERSONAL_ROOM_ACTIVATED_NOTIFICATION) {
            return <ChatLogItemPersonalRoomActivated message={message}/>
        } else if (type === SHOWROOM_ACTIVATED_NOTIFICATION) {
            return <ChatLogItemShowroomActivated message={message}/>
        } else if (type === TIP_NOTIFICATION) {
            return <ChatLogItemTip message={message} currentUser={currentUser} {...restProps}/>
        } else if (type === MEMBERSHIP_GIFT_NOTIFICATION) {
            return <ChatLogItemMembership message={message} currentUser={currentUser} {...restProps}/>
        } else if (type === USER_MUTED_NOTIFICATION) {
            return <ChatLogItemCensored message={message} muted />;
        } else if (type === USER_UNMUTED_NOTIFICATION) {
            return <ChatLogItemCensored message={message} />;
        } else {
            return <ChatLogItemGeneral message={message} user={user} currentUser={currentUser} currentRoomInfo={currentRoomInfo} {...restProps}/>
        }
    }
}

export default ChatLogItem;


// WEBPACK FOOTER //
// ./src/components/bobtv-neo/ChatLogItem/index.js